<template>
	<div>
		<div
			class="bg-emerald-700 px-3 md:px-4 py-2 cursor-pointer flex justify-between items-center gap-2 rounded-t"
			:class="{'rounded-b': !isExpanded}"
			@click="isExpanded = !isExpanded"
		>
			<div>
				<p class="text-white font-bold leading-tight">{{ t$.title }}</p>
				<p class="text-gray-200">
					<n-icon size="16" class="relative top-[2px] mr-2">
						<i-carbon-information-square-filled />
					</n-icon>
					<span class="text-sm leading-tight">{{ t$.cta }}</span>
				</p>
			</div>
			<n-icon size="32" class="text-white" :class="{'rotate-180': isExpanded}">
				<i-carbon-chevron-down />
			</n-icon>
		</div>
		<div class="bg-emerald-800 px-6 py-6 rounded-b" :class="{hidden: !isExpanded}">
			<p class="text-gray-100 mb-2 font-medium text-sm">{{ t$.description }}</p>
			<p class="text-gray-200/80 text-xs">
				<strong>{{ t$.conditions_1 }}</strong>
				{{ t$.conditions_2 }}
			</p>
		</div>
	</div>
</template>

<script setup>
	import {NIcon} from 'naive-ui'
	import ICarbonInformationSquareFilled from '~icons/carbon/information-square-filled'
	import ICarbonChevronDown from '~icons/carbon/chevron-down'
	import {getTranslations} from './translations'
	import {ref, toRefs} from 'vue'

	const props = defineProps({
		lang: Number,
	})
	const {lang} = toRefs(props)

	const t$ = getTranslations(lang.value)
	const isExpanded = ref(false)
</script>
